import { useI18n } from "@/context/I18nContext";
import {
    Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { OPS } from "@/constants/testIds";

const C = OPS.co;

/**
 * Branch picker. A cashier with one home branch sees it LOCKED; the
 * call-centre agent picks from every branch that has a till (the server's
 * `/co/scope.branches` is already restricted to POS branches).
 */
export function CoBranchSelect({ branches, value, onChange, required }) {
    const { t, tn } = useI18n();
    const list = branches || [];
    const current = list.find((b) => b.id === value);

    if (list.length <= 1 && !required) {
        return (
            <div data-testid={C.branchSelect} data-locked="true"
                 className="flex h-10 items-center gap-2 rounded-[var(--radius-sm)] border border-[color:var(--border-soft)] bg-[color:var(--bg-surface-2)] px-3 text-sm font-semibold text-[color:var(--ink)]">
                <span className="truncate">{current ? tn(current) : t("co_select_branch")}</span>
            </div>
        );
    }
    return (
        <Select value={value || ""} onValueChange={onChange}>
            <SelectTrigger data-testid={C.branchSelect} className="h-10 w-full">
                <SelectValue placeholder={t("co_select_branch")} />
            </SelectTrigger>
            <SelectContent>
                {list.map((b) => (
                    <SelectItem key={b.id} value={b.id} data-testid={C.branchOption(b.id)}>{tn(b)}</SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}

/** One row of tappable chips; `wrap` lets long lists flow onto new lines. */
export function ChipRow({ items, value, onChange, testId, lang, wrap = true, disabled }) {
    return (
        <div className={`flex gap-1.5 ${wrap ? "flex-wrap" : "overflow-x-auto"}`}>
            {items.map((it) => {
                const active = value === it.key;
                return (
                    <button key={it.key} type="button" data-testid={testId(it.key)} data-active={active ? "true" : "false"}
                            disabled={disabled} onClick={() => onChange(it.key)}
                            className={`h-9 shrink-0 rounded-full border px-3 text-xs font-semibold transition-[background-color,color,border-color] duration-150 ${
                                active
                                    ? "border-[color:var(--brand-orange)] bg-[color:var(--brand-orange)] text-white shadow-[var(--shadow-sm)]"
                                    : "border-[color:var(--border-soft)] bg-[color:var(--bg-surface)] text-[color:var(--ink)] hover:bg-[color:var(--brand-orange-soft)]"
                            } disabled:opacity-60`}>
                        {lang === "ar" ? it.name_ar || it.name_en : it.name_en || it.name_ar}
                    </button>
                );
            })}
        </div>
    );
}
